// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("margin-blue.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdforms-specs {
  /******************************************************************************
 *                   Style sheet for the W3C specifications                   *
 *
 * Special classes handled by this style sheet include:
 *
 * Indices
 *   - .toc for the Table of Contents (<ol class="toc">)
 *     + <span class="secno"> for the section numbers
 *   - #toc for the Table of Contents (<nav id="toc">)
 *   - ul.index for Indices (<a href="#ref">term</a><span>, in §N.M</span>)
 *   - table.index for Index Tables (e.g. for properties or elements)
 *
 * Structural Markup
 *   - table.data for general data tables
 *     -> use 'scope' attribute, <colgroup>, <thead>, and <tbody> for best results !
 *     -> use <table class='complex data'> for extra-complex tables
 *     -> use <td class='long'> for paragraph-length cell content
 *     -> use <td class='pre'> when manual line breaks/indentation would help readability
 *   - dl.switch for switch statements
 *   - ol.algorithm for algorithms (helps to visualize nesting)
 *   - .figure and .caption (HTML4) and figure and figcaption (HTML5)
 *     -> .sidefigure for right-floated figures
 *   - ins/del
 *
 * Code
 *   - pre and code
 *
 * Special Sections
 *   - .note       for informative notes             (div, p, span, aside, details)
 *   - .example    for informative examples          (div, p, pre, span)
 *   - .issue      for issues                        (div, p, span)
 *   - .advisement for loud normative statements     (div, p, strong)
 *   - .annoying-warning for spec obsoletion notices (div, aside, details)
 *
 * Definition Boxes
 *   - pre.def   for WebIDL definitions
 *   - table.def for tables that define other entities (e.g. CSS properties)
 *   - dl.def    for definition lists that define other entitles (e.g. HTML elements)
 *
 * Numbering
 *   - .secno for section numbers in .toc and headings (<span class='secno'>3.2</span>)
 *   - .marker for source-inserted example/figure/issue numbers (<span class='marker'>Issue 4</span>)
 *   - ::before styled for CSS-generated issue/example/figure numbers:
 *     -> Documents wishing to use this only need to add
 *        figcaption::before,
 *        .caption::before { content: "Figure "  counter(figure) " ";  }
 *        .example::before { content: "Example " counter(example) " "; }
 *        .issue::before   { content: "Issue "   counter(issue) " ";   }
 *
 * Header Stuff (ignore, just don't conflict with these classes)
 *   - .head for the header
 *   - .copyright for the copyright
 *
 * Outdated warning for old specs
 *
 * Miscellaneous
 *   - .overlarge for things that should be as wide as possible, even if
 *     that overflows the body text area. This can be used on an item or
 *     on its container, depending on the effect desired.
 *     Note that this styling basically doesn't help at all when printing,
 *     since A4 paper isn't much wider than the max-width here.
 *     It's better to design things to fit into a narrower measure if possible.
 *   - js-added ToC jump links (see tocControlls.js)
 *
 ******************************************************************************/
  /******************************************************************************/
  /*                         Front Matter & Navigation                          */
  /******************************************************************************/
  /** Header ********************************************************************/
  /** W3C Logo ******************************************************************/
  /* see also additional rules in Link Styling section */
  /** Copyright *****************************************************************/
  /** Back to Top / ToC Toggle **************************************************/
  /** ToC Sidebar ***************************************************************/
  /******************************************************************************/
  /*                                Sectioning                                  */
  /******************************************************************************/
  /** Headings ******************************************************************/
  /** Subheadings ***************************************************************/
  /** Section divider ***********************************************************/
  /******************************************************************************/
  /*                            Paragraphs and Lists                            */
  /******************************************************************************/
  /* Style for algorithms */
  /* Style for versions */
  /* Style for switch/case <dl>s */
  /** Terminology Markup ********************************************************/
  /******************************************************************************/
  /*                                 Inline Markup                              */
  /******************************************************************************/
  /** Terminology Markup ********************************************************/
  /** Change Marking ************************************************************/
  /** Miscellaneous improvements to inline formatting ***************************/
  /******************************************************************************/
  /*                                    Code                                    */
  /******************************************************************************/
  /** General monospace/pre rules ***********************************************/
  /** Inline Code fragments *****************************************************/
  /* Do something nice. */
  /******************************************************************************/
  /*                                    Links                                   */
  /******************************************************************************/
  /** General Hyperlinks ********************************************************/
  /* We hyperlink a lot, so make it less intrusive */
  /* Use distinguishing colors when user is interacting with the link */
  /* Backout above styling for W3C logo */
  /******************************************************************************/
  /*                                    Images                                  */
  /******************************************************************************/
  /* For autogen numbers, add
	   .caption::before, figcaption::before { content: "Figure " counter(figure) ". "; }
	*/
  /* DL list is indented 2em, but figure inside it is not */
  /******************************************************************************/
  /*                             Colored Boxes                                  */
  /******************************************************************************/
  /** Blockquotes ***************************************************************/
  /** Open issue ****************************************************************/
  /* Add .issue::before { content: "Issue " counter(issue) " "; } for autogen numbers,
	   or use class="marker" to mark up the issue number in source. */
  /** Example *******************************************************************/
  /* Add .example::before { content: "Example " counter(example) " "; } for autogen numbers,
	   or use class="marker" to mark up the example number in source. */
  /** Non-normative Note ********************************************************/
  /* Add .note::before { content: "Note "; } for autogen label,
	   or use class="marker" to mark up the label in source. */
  /** Advisement Box ************************************************************/
  /*  for attention-grabbing normative statements */
  /** Spec Obsoletion Notice ****************************************************/
  /* obnoxious obsoletion notice for older/abandoned specs. */
  /** Entity Definition Boxes ***************************************************/
  /******************************************************************************/
  /*                                    Tables                                  */
  /******************************************************************************/
  /** Property/Descriptor Definition Tables *************************************/
  /* For when values are extra-complex and need formatting for readability */
  /* A footnote at the bottom of a def table */
  /** Data tables (and properly marked-up index tables) *************************/
  /*
		 <table class="data"> highlights structural relationships in a table
		 when correct markup is used (e.g. thead/tbody, th vs. td, scope attribute)

		 Use class="complex data" for particularly complicated tables --
		 (This will draw more lines: busier, but clearer.)

		 Use class="long" on table cells with paragraph-like contents
		 (This will adjust text alignment accordingly.)
		 Alternately use class="longlastcol" on tables, to have the last column assume "long".
	*/
  /*
Alternate table alignment rules

	table.data,
	table.index {
		text-align: center;
	}

	table.data  thead th[scope="row"],
	table.index thead th[scope="row"] {
		text-align: right;
	}

	table.data  tbody th:first-child,
	table.index tbody th:first-child  {
		text-align: right;
	}

Possible extra rowspan handling

	table.data  tbody th[rowspan]:not([rowspan='1']),
	table.index tbody th[rowspan]:not([rowspan='1']),
	table.data  tbody td[rowspan]:not([rowspan='1']),
	table.index tbody td[rowspan]:not([rowspan='1']) {
		border-left: 1px solid silver;
	}

	table.data  tbody th[rowspan]:first-child,
	table.index tbody th[rowspan]:first-child,
	table.data  tbody td[rowspan]:first-child,
	table.index tbody td[rowspan]:first-child{
		border-left: 0;
		border-right: 1px solid silver;
	}
*/
  /******************************************************************************/
  /*                                  Indices                                   */
  /******************************************************************************/
  /** Table of Contents *********************************************************/
  /* ToC not indented until third level, but font style & margins show hierarchy */
  /* Section numbers in a column of their own */
  /* Tighten up indentation in narrow ToCs */
  /** Index *********************************************************************/
  /* Index Lists: Layout */
  /* Index Lists: Typography */
  /** Index Tables *****************************************************/
  /* See also the data table styling section, which this effectively subclasses */
  /* The link in the first column in the property table (formerly a TD) */
  /** Outdated warning **********************************************************/
  /******************************************************************************/
  /*                                    Print                                   */
  /******************************************************************************/
  /******************************************************************************/
  /*                                    Legacy                                  */
  /******************************************************************************/
  /* This rule is inherited from past style sheets. No idea what it's for. */
  /******************************************************************************/
  /*                             Overflow Control                               */
  /******************************************************************************/
}
.rdforms-specs div.head {
  margin-bottom: 1em;
}
.rdforms-specs div.head hr {
  border-style: solid;
}
.rdforms-specs div.head h1 {
  font-weight: bold;
  margin: 0 0 0.1em;
  font-size: 220%;
}
.rdforms-specs div.head h2 {
  margin-bottom: 1.5em;
}
.rdforms-specs .head p:not(.copyright):first-child {
  margin: 0;
}
.rdforms-specs .head p:not(.copyright):first-child > a,
.rdforms-specs .head > a:first-child {
  float: right;
  margin: 0.4rem 0 0.2rem 0.4rem;
}
.rdforms-specs .head img[src*="logos/W3C"] {
  display: block;
  border: solid #1a5e9a;
  border-width: 0.65rem 0.7rem 0.6rem;
  border-radius: 0.4rem;
  background: #1a5e9a;
  color: white;
  font-weight: bold;
}
.rdforms-specs .head a:hover > img[src*="logos/W3C"],
.rdforms-specs .head a:focus > img[src*="logos/W3C"] {
  opacity: 0.8;
}
.rdforms-specs .head a:active > img[src*="logos/W3C"] {
  background: #c00;
  border-color: #c00;
}
.rdforms-specs p.copyright,
.rdforms-specs p.copyright small {
  font-size: small;
}
@media print {
  .rdforms-specs #toc-nav {
    display: none;
  }
}
@media not print {
  .rdforms-specs {
    /* statusbar gets in the way on keyboard focus; remove once browsers fix */
  }
  .rdforms-specs #toc-nav {
    position: fixed;
    z-index: 2;
    bottom: 0;
    left: 0;
    margin: 0;
    min-width: 1.33em;
    border-top-right-radius: 2rem;
    box-shadow: 0 0 2px;
    font-size: 1.5em;
    color: black;
  }
  .rdforms-specs #toc-nav > a {
    display: block;
    white-space: nowrap;
    height: 1.33em;
    padding: 0.1em 0.3em;
    margin: 0;
    box-shadow: 0 0 2px;
    border: none;
    border-top-right-radius: 1.33em;
    background: white;
  }
  .rdforms-specs #toc-nav > #toc-jump {
    padding-bottom: 2em;
    margin-bottom: -1.9em;
  }
  .rdforms-specs #toc-nav > a:hover,
  .rdforms-specs #toc-nav > a:focus {
    background: #f8f8f8;
  }
  .rdforms-specs #toc-nav > a:not(:hover):not(:focus) {
    color: #707070;
  }
  .rdforms-specs #toc-nav > a[href="#toc"]:not(:hover):focus:last-child {
    padding-bottom: 1.5rem;
  }
  .rdforms-specs #toc-nav:not(:hover) > a:not(:focus) > span + span {
    /* Ideally this uses :focus-within on #toc-nav */
    display: none;
  }
  .rdforms-specs #toc-nav > a > span + span {
    padding-right: 0.2em;
  }
  .rdforms-specs #toc-toggle-inline {
    vertical-align: 0.05em;
    font-size: 80%;
    color: gray;
    color: hsla(203, 20%, 40%, 0.7);
    border-style: none;
    background: transparent;
    position: relative;
  }
  .rdforms-specs #toc-toggle-inline:hover:not(:active),
  .rdforms-specs #toc-toggle-inline:focus:not(:active) {
    text-shadow: 1px 1px silver;
    top: -1px;
    left: -1px;
  }
  .rdforms-specs #toc-nav :active {
    color: #C00;
  }
}
.rdforms-specs h1,
.rdforms-specs h2,
.rdforms-specs h3,
.rdforms-specs h4,
.rdforms-specs h5,
.rdforms-specs h6,
.rdforms-specs dt {
  page-break-after: avoid;
  page-break-inside: avoid;
  font: 100% sans-serif;
  /* Reset all font styling to clear out UA styles */
  font-family: inherit;
  /* Inherit the font family. */
  line-height: 1.2;
  /* Keep wrapped headings compact */
  hyphens: manual;
  /* Hyphenated headings look weird */
}
.rdforms-specs h2,
.rdforms-specs h3,
.rdforms-specs h4,
.rdforms-specs h5,
.rdforms-specs h6 {
  margin-top: 3rem;
}
.rdforms-specs h1,
.rdforms-specs h2,
.rdforms-specs h3 {
  color: #154862;
  background: transparent;
}
.rdforms-specs h1 {
  font-size: 170%;
}
.rdforms-specs h2 {
  font-size: 140%;
}
.rdforms-specs h3 {
  font-size: 120%;
}
.rdforms-specs h4 {
  font-weight: bold;
}
.rdforms-specs h5 {
  font-style: italic;
}
.rdforms-specs h6 {
  font-variant: small-caps;
}
.rdforms-specs dt {
  font-weight: bold;
}
.rdforms-specs h1 + h2,
.rdforms-specs #subtitle {
  /* #subtitle is a subtitle in an H2 under the H1 */
  margin-top: 0;
}
.rdforms-specs h2 + h3,
.rdforms-specs h3 + h4,
.rdforms-specs h4 + h5,
.rdforms-specs h5 + h6 {
  margin-top: 1.2em;
  /* = 1 x line-height */
}
.rdforms-specs :not(.head) > :not(.head) + hr {
  font-size: 1.5em;
  text-align: center;
  margin: 1em auto;
  height: auto;
  border: transparent solid 0;
  background: transparent;
}
.rdforms-specs :not(.head) > hr::before {
  content: "\\2727\\2003\\2003\\2727\\2003\\2003\\2727";
}
.rdforms-specs p {
  margin: 1em 0;
}
.rdforms-specs dd > p:first-child,
.rdforms-specs li > p:first-child {
  margin-top: 0;
}
.rdforms-specs ul,
.rdforms-specs ol {
  margin-left: 0;
  padding-left: 2em;
}
.rdforms-specs li {
  margin: 0.25em 0 0.5em;
  padding: 0;
}
.rdforms-specs dl dd {
  margin: 0 0 0.5em 2em;
}
.rdforms-specs .head dd + dd {
  /* compact for header */
  margin-top: -0.5em;
}
.rdforms-specs ol.algorithm ol:not(.algorithm),
.rdforms-specs .algorithm > ol ol:not(.algorithm) {
  border-left: 0.5em solid #DEF;
}
.rdforms-specs ul.versions {
  list-style-type: none;
}
.rdforms-specs ul.versions > li {
  font-weight: bold;
}
.rdforms-specs ul.versions ul {
  font-weight: normal;
  border-left: 0.5em solid #DEF;
  list-style-type: none;
}
.rdforms-specs ul.versions ul > li {
  text-indent: -15px;
}
.rdforms-specs ul.versions ul > li:before {
  content: "-  ";
  text-indent: -5px;
}
.rdforms-specs dl.switch > dd > ol.only {
  margin-left: 0;
}
.rdforms-specs dl.switch > dd > ol.algorithm {
  margin-left: -2em;
}
.rdforms-specs dl.switch {
  padding-left: 2em;
}
.rdforms-specs dl.switch > dt {
  text-indent: -1.5em;
  margin-top: 1em;
}
.rdforms-specs dl.switch > dt + dt {
  margin-top: 0;
}
.rdforms-specs dl.switch > dt::before {
  content: '\\21AA';
  padding: 0 0.5em 0 0;
  display: inline-block;
  width: 1em;
  text-align: right;
  line-height: 0.5em;
}
.rdforms-specs dfn {
  /* Defining instance */
  font-weight: bolder;
}
.rdforms-specs a > i {
  /* Instance of term */
  font-style: normal;
}
.rdforms-specs dt dfn code,
.rdforms-specs code.idl {
  font-size: inherit;
}
.rdforms-specs dfn var {
  font-style: normal;
}
.rdforms-specs del {
  color: red;
  text-decoration: line-through;
}
.rdforms-specs ins {
  color: #080;
  text-decoration: underline;
}
.rdforms-specs sup {
  vertical-align: super;
  font-size: 80%;
}
.rdforms-specs pre,
.rdforms-specs code,
.rdforms-specs samp {
  font-family: Menlo, Consolas, "DejaVu Sans Mono", Monaco, monospace;
  font-size: 0.9em;
  page-break-inside: avoid;
  hyphens: none;
  text-transform: none;
  text-align: left;
  text-align: start;
}
.rdforms-specs pre code,
.rdforms-specs code code {
  font-size: 100%;
}
.rdforms-specs pre {
  margin-top: 1em;
  margin-bottom: 1em;
  overflow: auto;
}
.rdforms-specs a[href] {
  color: #005A9C;
  /*MP WCAG2.1 contrast adaption, old value: #0071BC;*/
  text-decoration: none;
  border-bottom: 1px solid #0071BC;
  /* Need a bit of extending for it to look okay */
  padding: 0 1px 0;
  margin: 0 -1px 0;
}
.rdforms-specs a:visited {
  border-bottom-color: #BBB;
}
.rdforms-specs a[href]:focus,
.rdforms-specs a[href]:hover {
  background: #f8f8f8;
  background: rgba(191, 191, 191, 0.25);
  border-bottom-width: 3px;
  margin-bottom: -2px;
}
.rdforms-specs a[href]:active {
  color: #C00;
  border-color: #C00;
}
.rdforms-specs .head p:not(.copyright) > a,
.rdforms-specs .head > a:first-child {
  border: none;
  text-decoration: none;
  background: transparent;
}
.rdforms-specs img {
  border-style: none;
}
.rdforms-specs figure,
.rdforms-specs .figure,
.rdforms-specs .sidefigure {
  page-break-inside: avoid;
  text-align: center;
  margin: 2.5em 0;
}
.rdforms-specs .figure img,
.rdforms-specs .sidefigure img,
.rdforms-specs figure img,
.rdforms-specs .figure object,
.rdforms-specs .sidefigure object,
.rdforms-specs figure object {
  max-width: 100%;
  margin: auto;
  height: auto;
}
.rdforms-specs .figure pre,
.rdforms-specs .sidefigure pre,
.rdforms-specs figure pre {
  text-align: left;
  display: table;
  margin: 1em auto;
}
.rdforms-specs .figure table,
.rdforms-specs figure table {
  margin: auto;
}
@media screen and (min-width: 20em) {
  .rdforms-specs .sidefigure {
    float: right;
    width: 50%;
    margin: 0 0 0.5em 0.5em;
  }
}
.rdforms-specs .caption,
.rdforms-specs figcaption,
.rdforms-specs caption {
  font-style: italic;
  font-size: 90%;
}
.rdforms-specs .caption::before,
.rdforms-specs figcaption::before,
.rdforms-specs figcaption > .marker {
  font-weight: bold;
}
.rdforms-specs .caption,
.rdforms-specs figcaption {
  counter-increment: figure;
}
.rdforms-specs dd > .figure,
.rdforms-specs dd > figure {
  margin-left: -2em;
}
.rdforms-specs .issue,
.rdforms-specs .note,
.rdforms-specs .example,
.rdforms-specs .advisement,
.rdforms-specs blockquote {
  padding: 0.5em;
  border: 0.5em;
  border-left-style: solid;
  page-break-inside: avoid;
}
.rdforms-specs span.issue,
.rdforms-specs span.note {
  padding: 0.1em 0.5em 0.15em;
  border-right-style: solid;
}
.rdforms-specs .issue,
.rdforms-specs .note,
.rdforms-specs .example,
.rdforms-specs .advisement,
.rdforms-specs blockquote {
  margin: 1em auto;
}
.rdforms-specs .note > p:first-child,
.rdforms-specs .issue > p:first-child,
.rdforms-specs blockquote > :first-child {
  margin-top: 0;
}
.rdforms-specs blockquote > :last-child {
  margin-bottom: 0;
}
.rdforms-specs blockquote {
  border-color: silver;
}
.rdforms-specs .issue {
  border-color: #E05252;
  background: #FBE9E9;
  counter-increment: issue;
  overflow: auto;
}
.rdforms-specs .issue::before,
.rdforms-specs .issue > .marker {
  color: #AE1E1E;
  padding-right: 1em;
  text-transform: uppercase;
}
.rdforms-specs .example {
  border-color: #E0CB52;
  background: #FCFAEE;
  counter-increment: example;
  overflow: auto;
  clear: both;
}
.rdforms-specs .example::before,
.rdforms-specs .example > .marker {
  text-transform: uppercase;
  color: #827017;
  min-width: 7.5em;
  display: block;
}
.rdforms-specs .note {
  border-color: #52E052;
  background: #E9FBE9;
  overflow: auto;
}
.rdforms-specs .note::before,
.rdforms-specs .note > .marker,
.rdforms-specs details.note > summary::before,
.rdforms-specs details.note > summary > .marker {
  text-transform: uppercase;
  display: block;
  color: hsl(120, 70%, 30%);
}
.rdforms-specs details.note > summary {
  color: hsl(120, 70%, 30%);
}
.rdforms-specs details.note[open] > summary {
  border-bottom: 1px silver solid;
}
.rdforms-specs .advisement {
  border-color: orange;
  border-style: none solid;
  background: #FFEECC;
}
.rdforms-specs strong.advisement {
  display: block;
  text-align: center;
}
.rdforms-specs .advisement > .marker {
  color: #B35F00;
}
.rdforms-specs details {
  display: block;
}
.rdforms-specs summary {
  font-weight: bolder;
}
.rdforms-specs .annoying-warning:not(details),
.rdforms-specs details.annoying-warning:not([open]) > summary,
.rdforms-specs details.annoying-warning[open] {
  background: hsla(40, 100%, 50%, 0.95);
  color: black;
  padding: 0.75em 1em;
  border: red;
  border-style: solid none;
  box-shadow: 0 2px 8px black;
  text-align: center;
}
.rdforms-specs .annoying-warning :last-child {
  margin-bottom: 0;
}
@media not print {
  .rdforms-specs details.annoying-warning[open] {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 2em;
    z-index: 1000;
  }
}
.rdforms-specs details.annoying-warning:not([open]) > summary {
  text-align: center;
}
.rdforms-specs .def {
  padding: 0.5em 1em;
  background: #DEF;
  margin: 1.2em 0;
  border-left: 0.5em solid #8CCBF2;
}
.rdforms-specs th,
.rdforms-specs td {
  text-align: left;
  text-align: start;
}
.rdforms-specs table.def {
  /* inherits .def box styling, see above */
  width: 100%;
  border-spacing: 0;
}
.rdforms-specs table.def td,
.rdforms-specs table.def th {
  padding: 0.5em;
  vertical-align: baseline;
  border-bottom: 1px solid #bbd7e9;
}
.rdforms-specs table.def > tbody > tr:last-child th,
.rdforms-specs table.def > tbody > tr:last-child td {
  border-bottom: 0;
}
.rdforms-specs table.def th {
  font-style: italic;
  font-weight: normal;
  padding-left: 1em;
  width: 3em;
}
.rdforms-specs table td.pre {
  white-space: pre-wrap;
}
.rdforms-specs table.def td.footnote {
  padding-top: 0.6em;
}
.rdforms-specs table.def td.footnote::before {
  content: " ";
  display: block;
  height: 0.6em;
  width: 4em;
  border-top: thin solid;
}
.rdforms-specs table {
  word-wrap: normal;
  overflow-wrap: normal;
  hyphens: manual;
}
.rdforms-specs table.data,
.rdforms-specs table.index {
  margin: 1em auto;
  border-collapse: collapse;
  border: hidden;
  width: 100%;
}
.rdforms-specs table.data caption,
.rdforms-specs table.index caption {
  max-width: 50em;
  margin: 0 auto 1em;
}
.rdforms-specs table.data td,
.rdforms-specs table.data th,
.rdforms-specs table.index td,
.rdforms-specs table.index th {
  padding: 0.5em 1em;
  border-width: 1px;
  border-color: silver;
  border-top-style: solid;
}
.rdforms-specs table.data thead td:empty {
  padding: 0;
  border: 0;
}
.rdforms-specs table.data thead,
.rdforms-specs table.index thead,
.rdforms-specs table.data tbody,
.rdforms-specs table.index tbody {
  border-bottom: 2px solid;
}
.rdforms-specs table.data colgroup,
.rdforms-specs table.index colgroup {
  border-left: 2px solid;
}
.rdforms-specs table.data tbody th:first-child,
.rdforms-specs table.index tbody th:first-child {
  border-right: 2px solid;
  border-top: 1px solid silver;
  padding-right: 1em;
}
.rdforms-specs table.data th[colspan],
.rdforms-specs table.data td[colspan] {
  text-align: center;
}
.rdforms-specs table.complex.data th,
.rdforms-specs table.complex.data td {
  border: 1px solid silver;
  text-align: center;
}
.rdforms-specs table.data.longlastcol td:last-child,
.rdforms-specs table.data td.long {
  vertical-align: baseline;
  text-align: left;
}
.rdforms-specs table.data img {
  vertical-align: middle;
}
.rdforms-specs .toc a {
  /* More spacing; use padding to make it part of the click target. */
  padding-top: 0.1rem;
  /* Larger, more consistently-sized click target */
  display: block;
  /* Reverse color scheme */
  color: black;
  border-color: #0071BC;
}
.rdforms-specs .toc a:visited {
  border-color: #154862;
}
.rdforms-specs .toc a:not(:focus):not(:hover) {
  /* Allow colors to cascade through from link styling */
  border-bottom-color: transparent;
}
.rdforms-specs .toc,
.rdforms-specs .toc ol,
.rdforms-specs .toc ul,
.rdforms-specs .toc li {
  list-style: none;
  /* Numbers must be inlined into source */
  /* because generated content isn't search/selectable and markers can't do multilevel yet */
  margin: 0;
  padding: 0;
  line-height: 1.1rem;
  /* consistent spacing */
}
.rdforms-specs .toc > li {
  font-weight: bold;
}
.rdforms-specs .toc > li li {
  font-weight: normal;
}
.rdforms-specs .toc > li li li {
  font-size: 95%;
}
.rdforms-specs .toc > li li li li {
  font-size: 90%;
}
.rdforms-specs .toc > li li li li li {
  font-size: 85%;
}
.rdforms-specs .toc > li {
  margin: 1.5rem 0;
}
.rdforms-specs .toc > li li {
  margin: 0.3rem 0;
}
.rdforms-specs .toc > li li li {
  margin-left: 2rem;
}
.rdforms-specs .toc .secno {
  float: left;
  width: 4rem;
  white-space: nowrap;
}
.rdforms-specs .toc > li li li li .secno {
  font-size: 85%;
}
.rdforms-specs .toc > li li li li li .secno {
  font-size: 100%;
}
.rdforms-specs :not(li) > .toc {
  margin-left: 5rem;
}
.rdforms-specs .toc .secno {
  margin-left: -5rem;
}
.rdforms-specs .toc > li li li .secno {
  margin-left: -7rem;
}
.rdforms-specs .toc > li li li li .secno {
  margin-left: -9rem;
}
.rdforms-specs .toc > li li li li li .secno {
  margin-left: -11rem;
}
@media (max-width: 30em) {
  .rdforms-specs :not(li) > .toc {
    margin-left: 4rem;
  }
  .rdforms-specs .toc .secno {
    margin-left: -4rem;
  }
  .rdforms-specs .toc > li li li {
    margin-left: 1rem;
  }
  .rdforms-specs .toc > li li li .secno {
    margin-left: -5rem;
  }
  .rdforms-specs .toc > li li li li .secno {
    margin-left: -6rem;
  }
  .rdforms-specs .toc > li li li li li .secno {
    margin-left: -7rem;
  }
}
.rdforms-specs .toc li {
  clear: both;
}
.rdforms-specs ul.index {
  margin-left: 0;
  columns: 15em;
  text-indent: 1em hanging;
}
.rdforms-specs ul.index li {
  margin-left: 0;
  list-style: none;
  break-inside: avoid;
}
.rdforms-specs ul.index li li {
  margin-left: 1em;
}
.rdforms-specs ul.index dl {
  margin-top: 0;
}
.rdforms-specs ul.index dt {
  margin: 0.2em 0 0.2em 20px;
}
.rdforms-specs ul.index dd {
  margin: 0.2em 0 0.2em 40px;
}
.rdforms-specs ul.index ul,
.rdforms-specs ul.index dl {
  font-size: smaller;
}
@media not print {
  .rdforms-specs ul.index li span {
    white-space: nowrap;
    color: transparent;
  }
  .rdforms-specs ul.index li a:hover + span,
  .rdforms-specs ul.index li a:focus + span {
    color: #707070;
  }
}
.rdforms-specs table.index {
  font-size: small;
  border-collapse: collapse;
  border-spacing: 0;
  text-align: left;
  margin: 1em 0;
}
.rdforms-specs table.index td,
.rdforms-specs table.index th {
  padding: 0.4em;
}
.rdforms-specs table.index tr:hover td:not([rowspan]),
.rdforms-specs table.index tr:hover th:not([rowspan]) {
  background: #f7f8f9;
}
.rdforms-specs table.index th:first-child a {
  font-weight: bold;
}
.rdforms-specs a#outdated-note {
  color: white;
}
.rdforms-specs a#outdated-note:hover {
  background: transparent;
}
.rdforms-specs .outdated-spec {
  background-color: rgba(0, 0, 0, 0.5);
}
.rdforms-specs .outdated-warning {
  position: fixed;
  bottom: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 50%;
  background: maroon;
  color: white;
  border-radius: 1em;
  box-shadow: 0 0 1em red;
  padding: 2em;
  text-align: center;
  z-index: 2;
}
.rdforms-specs .edited-rec-warning {
  background: darkorange;
  box-shadow: 0 0 1em;
}
.rdforms-specs .outdated-warning button {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  border: 0;
  padding: 0.25em 0.5em;
  background: transparent;
  color: white;
  font: 1em sans-serif;
  text-align: center;
}
.rdforms-specs .outdated-warning span {
  display: block;
}
.rdforms-specs .outdated-collapsed {
  bottom: 0;
  border-radius: 0;
  width: 100%;
  padding: 0;
}
@media print {
  .rdforms-specs {
    /* Pages have their own margins. */
  }
  .rdforms-specs html {
    margin: 0;
  }
  .rdforms-specs .outdated-warning {
    position: absolute;
    border-style: solid;
    border-color: red;
  }
  .rdforms-specs .outdated-warning input {
    display: none;
  }
}
@page {
  margin: 1.5cm 1.1cm;
}
.rdforms-specs .hide {
  display: none;
}
.rdforms-specs .figure .caption,
.rdforms-specs .sidefigure .caption,
.rdforms-specs figcaption {
  /* in case figure is overlarge, limit caption to 50em */
  max-width: 50rem;
  margin-left: auto;
  margin-right: auto;
}
.rdforms-specs .overlarge > table {
  /* limit preferred width of table */
  max-width: 50em;
  margin-left: auto;
  margin-right: auto;
}
@media (min-width: 55em) {
  .rdforms-specs .overlarge {
    margin-left: calc(13px + 26.5rem - 50vw);
    margin-right: calc(13px + 26.5rem - 50vw);
    max-width: none;
  }
}
@media not print {
  .rdforms-specs .overlarge {
    overflow-x: auto;
    /* See Lea Verou's explanation background-attachment:
			 * http://lea.verou.me/2012/04/background-attachment-local/
			 *
			background: top left  / 4em 100% linear-gradient(to right,  #ffffff, rgba(255, 255, 255, 0)) local,
			            top right / 4em 100% linear-gradient(to left, #ffffff, rgba(255, 255, 255, 0)) local,
			            top left  / 1em 100% linear-gradient(to right,  #c3c3c5, rgba(195, 195, 197, 0)) scroll,
			            top right / 1em 100% linear-gradient(to left, #c3c3c5, rgba(195, 195, 197, 0)) scroll,
			            white;
			background-repeat: no-repeat;
			*/
  }
}
/******************************************************************************/
/*                                   Body                                     */
/******************************************************************************/
.rdforms-specs {
  counter-reset: example figure issue;
  /* Layout */
  max-width: 50em;
  /* limit line length to 50em for readability   */
  margin: 0 auto;
  /* center text within page                     */
  padding: 1.6em 1.5em 2em 50px;
  /* assume 16px font size for downlevel clients */
  padding: 1.6em 1.5em 2em calc(26px + 1.5em);
  /* leave space for status flag     */
  /* Typography */
  line-height: 1.5;
  font-family: sans-serif;
  widows: 2;
  orphans: 2;
  word-wrap: break-word;
  overflow-wrap: break-word;
  /* Colors */
  color: black;
  background: white top left fixed no-repeat;
  background-size: 25px auto;
}
/******************************************************************************/
/*                                    Print                                   */
/******************************************************************************/
@media print {
  /* Serif for print. */
  .rdforms-specs {
    font-family: serif;
  }
}
/* Floating sidebar */
@media screen {
  .rdforms-specs.toc-sidebar #toc {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 23.5em;
    max-width: 80%;
    max-width: calc(100% - 2em - 26px);
    overflow: auto;
    padding: 0 1em;
    padding-left: 42px;
    padding-left: calc(1em + 26px);
    background: inherit;
    background-color: #f7f8f9;
    z-index: 1;
    box-shadow: -0.1em 0 0.25em rgba(0, 0, 0, 0.1) inset;
  }
  .rdforms-specs.toc-sidebar #toc h2 {
    margin-top: 0.8rem;
    font-variant: small-caps;
    font-variant: all-small-caps;
    text-transform: lowercase;
    font-weight: bold;
    color: gray;
    color: hsla(203, 20%, 40%, 0.7);
  }
  .rdforms-specs.toc-sidebar #toc-jump:not(:focus) {
    width: 0;
    height: 0;
    padding: 0;
    position: absolute;
    overflow: hidden;
  }
}
/* Hide main scroller when only the ToC is visible anyway */
@media screen and (max-width: 28em) {
  .rdforms-specs.toc-sidebar {
    overflow: hidden;
  }
}
/* Sidebar with its own space */
@media screen and (min-width: 78em) {
  .rdforms-specs:not(.toc-inline) #toc {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 23.5em;
    overflow: auto;
    padding: 0 1em;
    padding-left: 42px;
    padding-left: calc(1em + 26px);
    background: inherit;
    background-color: #f7f8f9;
    z-index: 1;
    box-shadow: -0.1em 0 0.25em rgba(0, 0, 0, 0.1) inset;
  }
  .rdforms-specs:not(.toc-inline) #toc h2 {
    margin-top: 0.8rem;
    font-variant: small-caps;
    font-variant: all-small-caps;
    text-transform: lowercase;
    font-weight: bold;
    color: #154862;
  }
  .rdforms-specs:not(.toc-inline) {
    padding-left: 29em;
  }
  /* See also Overflow section at the bottom */
  .rdforms-specs:not(.toc-inline) #toc-jump:not(:focus) {
    width: 0;
    height: 0;
    padding: 0;
    position: absolute;
    overflow: hidden;
  }
}
@media screen and (min-width: 90em) {
  .rdforms-specs:not(.toc-inline) {
    margin: 0 4em;
  }
}
.rdforms-specs.toc-sidebar #toc :not(li) > .toc {
  margin-left: 4rem;
}
.rdforms-specs.toc-sidebar #toc .toc .secno {
  margin-left: -4rem;
}
.rdforms-specs.toc-sidebar #toc .toc > li li li {
  margin-left: 1rem;
}
.rdforms-specs.toc-sidebar #toc .toc > li li li .secno {
  margin-left: -5rem;
}
.rdforms-specs.toc-sidebar #toc .toc > li li li li .secno {
  margin-left: -6rem;
}
.rdforms-specs.toc-sidebar #toc .toc > li li li li li .secno {
  margin-left: -7rem;
}
@media screen and (min-width: 78em) {
  .rdforms-specs:not(.toc-inline) :not(li) > .toc {
    margin-left: 4rem;
  }
  .rdforms-specs:not(.toc-inline) .toc .secno {
    margin-left: -4rem;
  }
  .rdforms-specs:not(.toc-inline) .toc > li li li {
    margin-left: 1rem;
  }
  .rdforms-specs:not(.toc-inline) .toc > li li li .secno {
    margin-left: -5rem;
  }
  .rdforms-specs:not(.toc-inline) .toc > li li li li .secno {
    margin-left: -6rem;
  }
  .rdforms-specs:not(.toc-inline) .toc > li li li li li .secno {
    margin-left: -7rem;
  }
}
@media screen and (min-width: 78em) {
  .rdforms-specs:not(.toc-inline) .overlarge {
    /* 30.5em body padding 50em content area */
    margin-left: calc(40em - 50vw) !important;
    margin-right: calc(40em - 50vw) !important;
  }
}
@media screen and (min-width: 90em) {
  .rdforms-specs:not(.toc-inline) .overlarge {
    /* 4em html margin 30.5em body padding 50em content area */
    margin-left: 0 !important;
    margin-right: calc(84.5em - 100vw) !important;
  }
}
.rdforms-specs {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}
.rdforms-specs .logo img {
  height: 90px;
  margin-top: -10px;
}
.rdforms-specs .ms_datatable table.data tbody td:first-child,
.rdforms-specs .ms_datatable table.data thead th:first-child {
  border-right: 2px solid;
  border-top: 1px solid silver;
  padding-right: 1em;
}
`, "",{"version":3,"sources":["webpack://./assets/style.less","webpack://./assets/respec.css","webpack://./assets/respec-body.css"],"names":[],"mappings":"AAAA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;+EAgE6E;EAC7E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,sDAAsD;EACtD,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;EAChC,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,uBAAuB;EACvB,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,kDAAkD;EAClD,qEAAqE;EACrE,uCAAuC;EACvC,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E;;EAEA;EACA,yDAAyD;EACzD,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E;kEACgE;EAChE,+EAA+E;EAC/E;oEACkE;EAClE,+EAA+E;EAC/E;2DACyD;EACzD,+EAA+E;EAC/E,iDAAiD;EACjD,+EAA+E;EAC/E,2DAA2D;EAC3D,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,0EAA0E;EAC1E,4CAA4C;EAC5C,+EAA+E;EAC/E;;;;;;;;;;EAUA;EACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAkCD;EACC,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,gFAAgF;EAChF,6CAA6C;EAC7C,0CAA0C;EAC1C,+EAA+E;EAC/E,wBAAwB;EACxB,4BAA4B;EAC5B,sEAAsE;EACtE,+EAA+E;EAC/E,uEAAuE;EACvE,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;EAC/E,0EAA0E;EAC1E,+EAA+E;EAC/E,+EAA+E;EAC/E,+EAA+E;AACjF;AAjNA;ECwEY,kBAAA;AD4IZ;AApNA;ECyEe,mBAAA;AD8If;AAvNA;EC4EE,iBAAA;EACA,iBAAA;EACA,eAAA;AD8IF;AA5NA;ECiFe,oBAAA;AD8If;AA/NA;ECsFE,SAAA;AD4IF;AAlOA;;EC2FE,YAAA;EACA,8BAAA;AD2IF;AAvOA;ECgGE,cAAA;EACA,qBAAA;EACA,mCAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AD0IF;AAhPA;;EC2GE,YAAA;ADyIF;AApPA;EC+GE,gBAAA;EACA,kBAAA;ADwIF;AAxPA;;ECwHqB,gBAAA;ADoIrB;AChIC;EAAA;IAEE,aAAA;EDkID;AACF;AChIC;EAAA;IDmIG,0EAA0E;EAC5E;ECpID;IAEE,eAAA;IACA,UAAA;IACA,SAAA;IAAW,OAAA;IACX,SAAA;IACA,iBAAA;IACA,6BAAA;IACA,mBAAA;IACA,gBAAA;IACA,YAAA;EDsID;EChJD;IAaE,cAAA;IACA,mBAAA;IAEA,cAAA;IACA,oBAAA;IACA,SAAA;IAEA,mBAAA;IACA,YAAA;IACA,+BAAA;IACA,iBAAA;EDoID;EC3JD;IA0BE,mBAAA;IACA,qBAAA;EDoID;EC/JD;;IAgCE,mBAAA;EDmID;ECnKD;IAmCE,cAAA;EDmID;ECtKD;IAwCE,sBAAA;EDiID;ECzKD;ID2KG,gDAAgD;IC9HjD,aAAA;EDgID;EC7KD;IAgDE,oBAAA;EDgID;EChLD;IAoDE,sBAAA;IACA,cAAA;IACA,WAAA;IACA,+BAAA;IACA,kBAAA;IACA,uBAAA;IACA,kBAAA;ED+HD;ECzLD;;IA8DE,2BAAA;IACA,SAAA;IACA,UAAA;ED+HD;EC/LD;IAoEE,WAAA;ED8HD;AACF;AApUA;;;;;;;ECmNE,uBAAA;EACA,wBAAA;EACA,qBAAA;ED0HA,kDAAkD;ECzHlD,oBAAA;ED2HA,6BAA6B;EC1H7B,gBAAA;ED4HA,kCAAkC;EC3HlC,eAAA;ED6HA,mCAAmC;AACrC;AAtVA;;;;;EC4NE,gBAAA;ADiIF;AA7VA;;;ECgOE,cAAA;EACA,uBAAA;ADkIF;AAnWA;ECoOM,eAAA;ADkIN;AAtWA;ECqOM,eAAA;ADoIN;AAzWA;ECsOM,eAAA;ADsIN;AA5WA;ECuOM,iBAAA;ADwIN;AA/WA;ECwOM,kBAAA;AD0IN;AAlXA;ECyOM,wBAAA;AD4IN;AArXA;EC0OM,iBAAA;AD8IN;AAxXA;;EA2XE,kDAAkD;EC1IlD,aAAA;AD4IF;AA7XA;;;;ECuPE,iBAAA;ED4IA,sBAAsB;AACxB;AApYA;EC6PE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,uBAAA;AD0IF;AA5YA;ECqQE,8CAAA;AD0IF;AA/YA;EC6QE,aAAA;ADqIF;AAlZA;;ECkRE,aAAA;ADoIF;AAtZA;;ECsRE,cAAA;EACA,iBAAA;ADoIF;AA3ZA;EC2RE,sBAAA;EACA,UAAA;ADmIF;AA/ZA;ECgSE,qBAAA;ADkIF;AAlaA;EAoaE,uBAAuB;EChIvB,kBAAA;ADkIF;AAtaA;;EC2SK,6BAAA;AD+HL;AA1aA;ECgTE,qBAAA;AD6HF;AA7aA;ECmTE,iBAAA;AD6HF;AAhbA;ECsTE,mBAAA;EACA,6BAAA;EACA,qBAAA;AD6HF;AArbA;EC2TE,kBAAA;AD6HF;AAxbA;EC8TE,cAAA;EACA,iBAAA;AD6HF;AA5bA;ECoUE,cAAA;AD2HF;AA/bA;ECuUE,iBAAA;AD2HF;AAlcA;EC0UE,iBAAA;AD2HF;AArcA;EC6UE,mBAAA;EACA,eAAA;AD2HF;AAzcA;ECiVE,aAAA;AD2HF;AA5cA;ECoVE,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AD2HF;AApdA;EAsdE,sBAAsB;ECjHtB,mBAAA;ADmHF;AAxdA;EA0dE,qBAAqB;EClHrB,kBAAA;ADoHF;AA5dA;;EC2WE,kBAAA;ADqHF;AAheA;EC8WE,kBAAA;ADqHF;AAneA;ECmXO,UAAA;EAAa,6BAAA;ADoHpB;AAveA;ECoXO,WAAA;EAAa,0BAAA;ADuHpB;AA3eA;ECyXE,qBAAA;EACA,cAAA;ADqHF;AA/eA;;;ECoYE,mEAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;ADgHF;AA1fA;;EC8YE,eAAA;ADgHF;AA9fA;ECkZE,eAAA;EACA,kBAAA;EACA,cAAA;AD+GF;AAngBA;ECmaE,cAAA;EDmGA,oDAAoD;EClGpD,qBAAA;EACA,gCAAA;EDoGA,gDAAgD;EClGhD,gBAAA;EACA,gBAAA;ADoGF;AA5gBA;EC2aE,yBAAA;ADoGF;AA/gBA;;ECibE,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;ADkGF;AAthBA;ECubE,WAAA;EACA,kBAAA;ADkGF;AA1hBA;;EC8bE,YAAA;EACA,qBAAA;EACA,uBAAA;ADgGF;AAhiBA;ECwcE,kBAAA;AD2FF;AAniBA;;;ECgdE,wBAAA;EACA,kBAAA;EACA,eAAA;ADwFF;AA1iBA;;;;;;ECsdE,eAAA;EACA,YAAA;EACA,YAAA;AD4FF;AApjBA;;;EC2dE,gBAAA;EACA,cAAA;EACA,gBAAA;AD8FF;AA3jBA;;ECgeE,YAAA;AD+FF;AC7FC;EAAA;IAEE,YAAA;IACA,UAAA;IACA,uBAAA;ED+FD;AACF;AAtkBA;;;EC0eE,kBAAA;EACA,cAAA;ADiGF;AA5kBA;;;EC8eE,iBAAA;ADmGF;AAjlBA;;ECifE,yBAAA;ADoGF;AArlBA;;ECqf6B,iBAAA;ADoG7B;AAzlBA;;;;;EC4fE,cAAA;EACA,aAAA;EACA,wBAAA;EACA,wBAAA;ADoGF;AAnmBA;;ECkgBE,2BAAA;EACA,yBAAA;ADqGF;AAxmBA;;;;;EC2gBE,gBAAA;ADoGF;AA/mBA;;;ECghBE,aAAA;ADoGF;AApnBA;ECmhBE,gBAAA;ADoGF;AAvnBA;ECyhBE,oBAAA;ADiGF;AA1nBA;EC+hBE,qBAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;AD8FF;AAhoBA;;ECqiBE,cAAA;EACA,kBAAA;EACA,yBAAA;AD+FF;AAtoBA;EC+iBE,qBAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,WAAA;AD0FF;AA7oBA;;ECsjBE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AD2FF;AAppBA;ECikBE,qBAAA;EACA,mBAAA;EACA,cAAA;ADsFF;AAzpBA;;;;ECykBE,yBAAA;EACA,cAAA;EACA,yBAAA;ADsFF;AAjqBA;ECilBE,yBAAA;ADmFF;AApqBA;EColBE,+BAAA;ADmFF;AAvqBA;EC2lBE,oBAAA;EACA,wBAAA;EACA,mBAAA;AD+EF;AA5qBA;ECgmBE,cAAA;EACA,kBAAA;AD+EF;AAhrBA;EComBE,cAAA;AD+EF;AAnrBA;EC2mBE,cAAA;AD2EF;AAtrBA;EC8mBE,mBAAA;AD2EF;AAzrBA;;;EConBE,qCAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,2BAAA;EACA,kBAAA;AD0EF;AApsBA;EC6nBE,gBAAA;AD0EF;ACvEA;EAAA;IAEE,eAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,aAAA;EDyEA;AACF;AAhtBA;EC2oBE,kBAAA;ADwEF;AAntBA;ECipBE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;ADqEF;AAztBA;;EC4pBE,gBAAA;EACA,iBAAA;ADiEF;AA9tBA;EAguBE,yCAAyC;EC5DzC,WAAA;EACA,iBAAA;AD8DF;AAnuBA;;EC0qBE,cAAA;EACA,wBAAA;EACA,gCAAA;AD6DF;AAzuBA;;ECirBE,gBAAA;AD4DF;AA7uBA;ECqrBE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AD2DF;AAnvBA;EC6rBE,qBAAA;ADyDF;AAtvBA;ECksBE,kBAAA;ADuDF;AAzvBA;ECqsBE,YAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,sBAAA;ADuDF;AAhwBA;EC0tBE,iBAAA;EACA,qBAAA;EACA,eAAA;ADyCF;AArwBA;;ECiuBE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;ADwCF;AA5wBA;;ECwuBE,eAAA;EACA,kBAAA;ADwCF;AAjxBA;;;;EC8uBE,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;ADyCF;AA1xBA;ECqvBE,UAAA;EACA,SAAA;ADwCF;AA9xBA;;;;EC6vBE,wBAAA;ADuCF;AApyBA;;ECkwBE,sBAAA;ADsCF;AAxyBA;;ECuwBE,uBAAA;EACA,4BAAA;EACA,kBAAA;ADqCF;AA9yBA;;EC8wBE,kBAAA;ADoCF;AAlzBA;;ECmxBE,wBAAA;EACA,kBAAA;ADmCF;AAvzBA;;ECyxBE,wBAAA;EACA,gBAAA;ADkCF;AA5zBA;EC8xBE,sBAAA;ADiCF;AA/zBA;EAi0BE,mEAAmE;ECcnE,mBAAA;EDZA,iDAAiD;ECcjD,cAAA;EDZA,yBAAyB;ECczB,YAAA;EACA,qBAAA;ADZF;AAx0BA;ECu1BE,qBAAA;ADZF;AA30BA;EA60BE,sDAAsD;ECctD,gCAAA;ADZF;AA/0BA;;;;EC+1BE,gBAAA;EDVA,wCAAwC;EACxC,0FAA0F;ECW1F,SAAA;EACA,UAAA;EACA,mBAAA;EDTA,uBAAuB;AACzB;AA31BA;ECu2ByB,iBAAA;ADTzB;AA91BA;ECw2ByB,mBAAA;ADPzB;AAj2BA;ECy2ByB,cAAA;ADLzB;AAp2BA;EC02ByB,cAAA;ADHzB;AAv2BA;EC22ByB,cAAA;ADDzB;AA12BA;EC62ByB,gBAAA;ADAzB;AA72BA;EC82ByB,gBAAA;ADEzB;AAh3BA;EC+2ByB,iBAAA;ADIzB;AAn3BA;ECm3BE,WAAA;EACA,WAAA;EACA,mBAAA;ADGF;AAx3BA;ECw3BE,cAAA;ADGF;AA33BA;EC23BE,eAAA;ADGF;AA93BA;EC83BgC,iBAAA;ADGhC;AAj4BA;EC+3BgC,kBAAA;ADKhC;AAp4BA;ECg4BgC,kBAAA;ADOhC;AAv4BA;ECi4BgC,kBAAA;ADShC;AA14BA;ECk4BgC,mBAAA;ADWhC;ACRC;EAAA;IACgC,iBAAA;EDW/B;ECZD;IAEgC,kBAAA;EDa/B;ECfD;IAGgC,iBAAA;EDe/B;EClBD;IAIgC,kBAAA;EDiB/B;ECrBD;IAKgC,kBAAA;EDmB/B;ECxBD;IAMgC,kBAAA;EDqB/B;AACF;AAj6BA;EC+4BE,WAAA;ADqBF;AAp6BA;ECs5BkB,cAAA;EAAgB,aAAA;EAAe,wBAAA;ADmBjD;AAz6BA;ECu5BkB,cAAA;EAAgB,gBAAA;EAAkB,mBAAA;ADuBpD;AA96BA;ECw5BkB,gBAAA;ADyBlB;AAj7BA;ECy5BkB,aAAA;AD2BlB;AAp7BA;EC05BkB,0BAAA;AD6BlB;AAv7BA;EC25BkB,0BAAA;AD+BlB;AA17BA;;EC85Be,kBAAA;ADgCf;AC/BC;EAAA;IAEE,mBAAA;IACA,kBAAA;EDiCD;ECpCD;;IAOE,cAAA;EDiCD;AACF;AAx8BA;EC86BE,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AD6BF;AA/8BA;;ECu7BE,cAAA;AD4BF;AAn9BA;;EC47BE,mBAAA;AD2BF;AAv9BA;ECi8BE,iBAAA;ADyBF;AA19BA;ECu8BC,YAAA;ADsBD;AA79BA;EC28BC,uBAAA;ADqBD;AAh+BA;EC+8BC,oCAAA;ADoBD;AAn+BA;ECm9BC,eAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;ADmBD;AAl/BA;ECm+BC,sBAAA;EACA,mBAAA;ADkBD;AAt/BA;ECw+BC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;ADiBD;AAlgCA;ECq/BC,cAAA;ADgBD;AArgCA;ECy/BC,SAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;ADeD;ACRC;EAAA;IDWG,kCAAkC;EACpC;ECZD;IAGE,SAAA;EDYD;ECfD;IAOE,kBAAA;IACA,mBAAA;IACA,iBAAA;EDWD;ECpBD;IAaE,aAAA;EDUD;AACF;ACRC;EACC,mBAAA;ADUF;AA9hCA;EC4hCS,aAAA;ADKT;AAjiCA;;;EAqiCE,uDAAuD;ECCvD,gBAAA;EACA,iBAAA;EACA,kBAAA;ADCF;AAziCA;EA2iCE,mCAAmC;ECCnC,eAAA;EACA,iBAAA;EACA,kBAAA;ADCF;ACEC;EAAA;IAEE,wCAAA;IACA,yCAAA;IACA,eAAA;EDAD;AACF;ACGC;EAAA;IAEE,gBAAA;IDDC;;;;;;;;;IASA;EACF;AACF;AACA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AEpkC9E;EACC,mCAAA;EFskCA,WAAW;EEnkCX,eAAA;EFqkCA,gDAAgD;EEpkChD,cAAA;EFskCA,gDAAgD;EErkChD,6BAAA;EFukCA,gDAAgD;EEtkChD,2CAAA;EFwkCA,oCAAoC;EACpC,eAAe;EEtkCf,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,yBAAA;EFwkCA,WAAW;EErkCX,YAAA;EACA,0CAAA;EACA,0BAAA;AFukCF;AACA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AElkC/E;EFokCE,qBAAqB;EElkCtB;IACC,kBAAA;EFokCA;AACF;AACA,qBAAqB;AEjkCrB;EACC;IACC,eAAA;IACA,MAAA;IAAQ,SAAA;IACR,OAAA;IACA,aAAA;IACA,cAAA;IACA,kCAAA;IACA,cAAA;IACA,cAAA;IACA,kBAAA;IACA,8BAAA;IACA,mBAAA;IACA,yBAAA;IACA,UAAA;IACA,oDAAA;EFokCA;EElkCD;IACC,kBAAA;IACA,wBAAA;IACA,4BAAA;IACA,yBAAA;IACA,iBAAA;IACA,WAAA;IACA,+BAAA;EFokCA;EElkCD;IACC,QAAA;IACA,SAAA;IACA,UAAA;IACA,kBAAA;IACA,gBAAA;EFokCA;AACF;AACA,2DAA2D;AElkC3D;EACC;IACC,gBAAA;EFokCA;AACF;AACA,+BAA+B;AEjkC/B;EACC;IACC,eAAA;IACA,MAAA;IAAQ,SAAA;IACR,OAAA;IACA,aAAA;IACA,cAAA;IACA,cAAA;IACA,kBAAA;IACA,8BAAA;IACA,mBAAA;IACA,yBAAA;IACA,UAAA;IACA,oDAAA;EFokCA;EElkCD;IACC,kBAAA;IACA,wBAAA;IACA,4BAAA;IACA,yBAAA;IACA,iBAAA;IACA,cAAA;EFokCA;EEjkCD;IACC,kBAAA;EFmkCA;EACA,4CAA4C;EEhkC7C;IACC,QAAA;IACA,SAAA;IACA,UAAA;IACA,kBAAA;IACA,gBAAA;EFkkCA;AACF;AEhkCA;EACC;IACC,aAAA;EFkkCA;AACF;AE9jCA;EAA+D,iBAAA;AFikC/D;AEhkCA;EAA+D,kBAAA;AFmkC/D;AElkCA;EAA+D,iBAAA;AFqkC/D;AEpkCA;EAA+D,kBAAA;AFukC/D;AEtkCA;EAA+D,kBAAA;AFykC/D;AExkCA;EAA+D,kBAAA;AF2kC/D;AEzkCA;EACC;IAA+D,iBAAA;EF4kC9D;EE3kCD;IAA+D,kBAAA;EF8kC9D;EE7kCD;IAA+D,iBAAA;EFglC9D;EE/kCD;IAA+D,kBAAA;EFklC9D;EEjlCD;IAA+D,kBAAA;EFolC9D;EEnlCD;IAA+D,kBAAA;EFslC9D;AACF;AEplCA;EACC;IFslCG,0CAA0C;IEplC5C,yCAAA;IACA,0CAAA;EFslCA;AACF;AEplCA;EACC;IFslCG,0DAA0D;IEplC5D,yBAAA;IACA,6CAAA;EFslCA;AACF;AA3uCA;EACE,oEAAA;AA6uCF;AA1uCA;EACE,YAAA;EACA,iBAAA;AA4uCF;AAzuCA;;EAEE,uBAAA;EACA,4BAAA;EACA,kBAAA;AA2uCF","sourcesContent":[".rdforms-specs {\n  @import (less) 'respec.css';\n}\n@import (less) \"respec-body.css\";\n\n.rdforms-specs {\n  background-image: url(margin-blue.png) !important;\n}\n\n.rdforms-specs .logo img {\n  height: 90px;\n  margin-top: -10px;\n}\n\n.rdforms-specs .ms_datatable table.data tbody td:first-child,\n.rdforms-specs .ms_datatable table.data thead th:first-child  {\n  border-right: 2px solid;\n  border-top: 1px solid silver;\n  padding-right: 1em;\n}","/******************************************************************************\n *                   Style sheet for the W3C specifications                   *\n *\n * Special classes handled by this style sheet include:\n *\n * Indices\n *   - .toc for the Table of Contents (<ol class=\"toc\">)\n *     + <span class=\"secno\"> for the section numbers\n *   - #toc for the Table of Contents (<nav id=\"toc\">)\n *   - ul.index for Indices (<a href=\"#ref\">term</a><span>, in §N.M</span>)\n *   - table.index for Index Tables (e.g. for properties or elements)\n *\n * Structural Markup\n *   - table.data for general data tables\n *     -> use 'scope' attribute, <colgroup>, <thead>, and <tbody> for best results !\n *     -> use <table class='complex data'> for extra-complex tables\n *     -> use <td class='long'> for paragraph-length cell content\n *     -> use <td class='pre'> when manual line breaks/indentation would help readability\n *   - dl.switch for switch statements\n *   - ol.algorithm for algorithms (helps to visualize nesting)\n *   - .figure and .caption (HTML4) and figure and figcaption (HTML5)\n *     -> .sidefigure for right-floated figures\n *   - ins/del\n *\n * Code\n *   - pre and code\n *\n * Special Sections\n *   - .note       for informative notes             (div, p, span, aside, details)\n *   - .example    for informative examples          (div, p, pre, span)\n *   - .issue      for issues                        (div, p, span)\n *   - .advisement for loud normative statements     (div, p, strong)\n *   - .annoying-warning for spec obsoletion notices (div, aside, details)\n *\n * Definition Boxes\n *   - pre.def   for WebIDL definitions\n *   - table.def for tables that define other entities (e.g. CSS properties)\n *   - dl.def    for definition lists that define other entitles (e.g. HTML elements)\n *\n * Numbering\n *   - .secno for section numbers in .toc and headings (<span class='secno'>3.2</span>)\n *   - .marker for source-inserted example/figure/issue numbers (<span class='marker'>Issue 4</span>)\n *   - ::before styled for CSS-generated issue/example/figure numbers:\n *     -> Documents wishing to use this only need to add\n *        figcaption::before,\n *        .caption::before { content: \"Figure \"  counter(figure) \" \";  }\n *        .example::before { content: \"Example \" counter(example) \" \"; }\n *        .issue::before   { content: \"Issue \"   counter(issue) \" \";   }\n *\n * Header Stuff (ignore, just don't conflict with these classes)\n *   - .head for the header\n *   - .copyright for the copyright\n *\n * Outdated warning for old specs\n *\n * Miscellaneous\n *   - .overlarge for things that should be as wide as possible, even if\n *     that overflows the body text area. This can be used on an item or\n *     on its container, depending on the effect desired.\n *     Note that this styling basically doesn't help at all when printing,\n *     since A4 paper isn't much wider than the max-width here.\n *     It's better to design things to fit into a narrower measure if possible.\n *   - js-added ToC jump links (see tocControlls.js)\n *\n ******************************************************************************/\n\n/******************************************************************************/\n/*                         Front Matter & Navigation                          */\n/******************************************************************************/\n\n/** Header ********************************************************************/\n\n\tdiv.head { margin-bottom: 1em; }\n\tdiv.head hr { border-style: solid; }\n\n\tdiv.head h1 {\n\t\tfont-weight: bold;\n\t\tmargin: 0 0 .1em;\n\t\tfont-size: 220%;\n\t}\n\n\tdiv.head h2 { margin-bottom: 1.5em;}\n\n/** W3C Logo ******************************************************************/\n\n\t.head p:not(.copyright):first-child {\n\t\tmargin: 0;\n\t}\n\n\t.head p:not(.copyright):first-child > a,\n\t.head > a:first-child {\n\t\tfloat: right;\n\t\tmargin: 0.4rem 0 0.2rem .4rem;\n\t}\n\n\t.head img[src*=\"logos/W3C\"] {\n\t\tdisplay: block;\n\t\tborder: solid #1a5e9a;\n\t\tborder-width: .65rem .7rem .6rem;\n\t\tborder-radius: .4rem;\n\t\tbackground: #1a5e9a;\n\t\tcolor: white;\n\t\tfont-weight: bold;\n\t}\n\n\t.head a:hover > img[src*=\"logos/W3C\"],\n\t.head a:focus > img[src*=\"logos/W3C\"] {\n\t\topacity: .8;\n\t}\n\n\t.head a:active > img[src*=\"logos/W3C\"] {\n\t\tbackground: #c00;\n\t\tborder-color: #c00;\n\t}\n\n\t/* see also additional rules in Link Styling section */\n\n/** Copyright *****************************************************************/\n\n\tp.copyright,\n\tp.copyright small { font-size: small; }\n\n/** Back to Top / ToC Toggle **************************************************/\n\n\t@media print {\n\t\t#toc-nav {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t@media not print {\n\t\t#toc-nav {\n\t\t\tposition: fixed;\n\t\t\tz-index: 2;\n\t\t\tbottom: 0; left: 0;\n\t\t\tmargin: 0;\n\t\t\tmin-width: 1.33em;\n\t\t\tborder-top-right-radius: 2rem;\n\t\t\tbox-shadow: 0 0 2px;\n\t\t\tfont-size: 1.5em;\n\t\t\tcolor: black;\n\t\t}\n\t\t#toc-nav > a {\n\t\t\tdisplay: block;\n\t\t\twhite-space: nowrap;\n\n\t\t\theight: 1.33em;\n\t\t\tpadding: .1em 0.3em;\n\t\t\tmargin: 0;\n\n\t\t\tbox-shadow: 0 0 2px;\n\t\t\tborder: none;\n\t\t\tborder-top-right-radius: 1.33em;\n\t\t\tbackground: white;\n\t\t}\n\t\t#toc-nav > #toc-jump {\n\t\t\tpadding-bottom: 2em;\n\t\t\tmargin-bottom: -1.9em;\n\t\t}\n\n\t\t#toc-nav > a:hover,\n\t\t#toc-nav > a:focus {\n\t\t\tbackground: #f8f8f8;\n\t\t}\n\t\t#toc-nav > a:not(:hover):not(:focus) {\n\t\t\tcolor: #707070;\n\t\t}\n\n\t\t/* statusbar gets in the way on keyboard focus; remove once browsers fix */\n\t\t#toc-nav > a[href=\"#toc\"]:not(:hover):focus:last-child {\n\t\t\tpadding-bottom: 1.5rem;\n\t\t}\n\n\t\t#toc-nav:not(:hover) > a:not(:focus) > span + span {\n\t\t\t/* Ideally this uses :focus-within on #toc-nav */\n\t\t\tdisplay: none;\n\t\t}\n\t\t#toc-nav > a > span + span {\n\t\t\tpadding-right: 0.2em;\n\t\t}\n\n\t\t#toc-toggle-inline {\n\t\t\tvertical-align: 0.05em;\n\t\t\tfont-size: 80%;\n\t\t\tcolor: gray;\n\t\t\tcolor: hsla(203,20%,40%,.7);\n\t\t\tborder-style: none;\n\t\t\tbackground: transparent;\n\t\t\tposition: relative;\n\t\t}\n\t\t#toc-toggle-inline:hover:not(:active),\n\t\t#toc-toggle-inline:focus:not(:active) {\n\t\t\ttext-shadow: 1px 1px silver;\n\t\t\ttop: -1px;\n\t\t\tleft: -1px;\n\t\t}\n\n\t\t#toc-nav :active {\n\t\t\tcolor: #C00;\n\t\t}\n\t}\n\n/** ToC Sidebar ***************************************************************/\n\n\n/******************************************************************************/\n/*                                Sectioning                                  */\n/******************************************************************************/\n\n/** Headings ******************************************************************/\n\n\th1, h2, h3, h4, h5, h6, dt {\n\t\tpage-break-after: avoid;\n\t\tpage-break-inside: avoid;\n\t\tfont: 100% sans-serif;   /* Reset all font styling to clear out UA styles */\n\t\tfont-family: inherit;    /* Inherit the font family. */\n\t\tline-height: 1.2;        /* Keep wrapped headings compact */\n\t\thyphens: manual;         /* Hyphenated headings look weird */\n\t}\n\n\th2, h3, h4, h5, h6 {\n\t\tmargin-top: 3rem;\n\t}\n\n\th1, h2, h3 {\n\t\tcolor: #154862;\n\t\tbackground: transparent;\n\t}\n\n\th1 { font-size: 170%; }\n\th2 { font-size: 140%; }\n\th3 { font-size: 120%; }\n\th4 { font-weight: bold; }\n\th5 { font-style: italic; }\n\th6 { font-variant: small-caps; }\n\tdt { font-weight: bold; }\n\n/** Subheadings ***************************************************************/\n\n\th1 + h2,\n\t#subtitle {\n\t\t/* #subtitle is a subtitle in an H2 under the H1 */\n\t\tmargin-top: 0;\n\t}\n\th2 + h3,\n\th3 + h4,\n\th4 + h5,\n\th5 + h6 {\n\t\tmargin-top: 1.2em; /* = 1 x line-height */\n\t}\n\n/** Section divider ***********************************************************/\n\n\t:not(.head) > :not(.head) + hr {\n\t\tfont-size: 1.5em;\n\t\ttext-align: center;\n\t\tmargin: 1em auto;\n\t\theight: auto;\n\t\tborder: transparent solid 0;\n\t\tbackground: transparent;\n\t}\n\t:not(.head) > hr::before {\n\t\tcontent: \"\\2727\\2003\\2003\\2727\\2003\\2003\\2727\";\n\t}\n\n/******************************************************************************/\n/*                            Paragraphs and Lists                            */\n/******************************************************************************/\n\n\tp {\n\t\tmargin: 1em 0;\n\t}\n\n\tdd > p:first-child,\n\tli > p:first-child {\n\t\tmargin-top: 0;\n\t}\n\n\tul, ol {\n\t\tmargin-left: 0;\n\t\tpadding-left: 2em;\n\t}\n\n\tli {\n\t\tmargin: 0.25em 0 0.5em;\n\t\tpadding: 0;\n\t}\n\n\tdl dd {\n\t\tmargin: 0 0 .5em 2em;\n\t}\n\n\t.head dd + dd { /* compact for header */\n\t\tmargin-top: -.5em;\n\t}\n\n\t/* Style for algorithms */\n\n\tol.algorithm ol:not(.algorithm),\n\t.algorithm > ol ol:not(.algorithm) {\n\t    border-left: 0.5em solid #DEF;\n\t}\n\n    /* Style for versions */\n    ul.versions {\n\t\tlist-style-type: none;\n\t}\n\tul.versions>li {\n\t\tfont-weight: bold;\n\t}\n    ul.versions ul {\n\t\tfont-weight: normal;\n\t\tborder-left: 0.5em solid #DEF;\n\t\tlist-style-type: none;\n\t}\n    ul.versions ul > li {\n\t\ttext-indent: -15px;\n\t}\n    ul.versions ul > li:before {\n\t\tcontent: \"-  \";\n\t\ttext-indent: -5px;\n\t}\n\n\t/* Style for switch/case <dl>s */\n\tdl.switch > dd > ol.only {\n\t margin-left: 0;\n\t}\n\tdl.switch > dd > ol.algorithm {\n\t margin-left: -2em;\n\t}\n\tdl.switch {\n\t padding-left: 2em;\n\t}\n\tdl.switch > dt {\n\t text-indent: -1.5em;\n\t margin-top: 1em;\n\t}\n\tdl.switch > dt + dt {\n\t margin-top: 0;\n\t}\n\tdl.switch > dt::before {\n\t content: '\\21AA';\n\t padding: 0 0.5em 0 0;\n\t display: inline-block;\n\t width: 1em;\n\t text-align: right;\n\t line-height: 0.5em;\n\t}\n\n/** Terminology Markup ********************************************************/\n\n\n/******************************************************************************/\n/*                                 Inline Markup                              */\n/******************************************************************************/\n\n/** Terminology Markup ********************************************************/\n\tdfn   { /* Defining instance */\n\t\tfont-weight: bolder;\n\t}\n\ta > i { /* Instance of term */\n\t\tfont-style: normal;\n\t}\n\tdt dfn code, code.idl {\n\t\tfont-size: inherit;\n\t}\n\tdfn var {\n\t\tfont-style: normal;\n\t}\n\n/** Change Marking ************************************************************/\n\n\tdel { color: red;  text-decoration: line-through; }\n\tins { color: #080; text-decoration: underline;    }\n\n/** Miscellaneous improvements to inline formatting ***************************/\n\n\tsup {\n\t\tvertical-align: super;\n\t\tfont-size: 80%;\n\t}\n\n/******************************************************************************/\n/*                                    Code                                    */\n/******************************************************************************/\n\n/** General monospace/pre rules ***********************************************/\n\n\tpre, code, samp {\n\t\tfont-family: Menlo, Consolas, \"DejaVu Sans Mono\", Monaco, monospace;\n\t\tfont-size: .9em;\n\t\tpage-break-inside: avoid;\n\t\thyphens: none;\n\t\ttext-transform: none;\n\t\ttext-align: left;\n\t\ttext-align: start;\n\t}\n\tpre code,\n\tcode code {\n\t\tfont-size: 100%;\n\t}\n\n\tpre {\n\t\tmargin-top: 1em;\n\t\tmargin-bottom: 1em;\n\t\toverflow: auto;\n\t}\n\n/** Inline Code fragments *****************************************************/\n\n  /* Do something nice. */\n\n/******************************************************************************/\n/*                                    Links                                   */\n/******************************************************************************/\n\n/** General Hyperlinks ********************************************************/\n\n\t/* We hyperlink a lot, so make it less intrusive */\n\ta[href] {\n\t\tcolor: #005A9C; /*MP WCAG2.1 contrast adaption, old value: #0071BC;*/\n\t\ttext-decoration: none;\n\t\tborder-bottom: 1px solid #0071BC;\n\t\t/* Need a bit of extending for it to look okay */\n\t\tpadding: 0 1px 0;\n\t\tmargin: 0 -1px 0;\n\t}\n\ta:visited {\n\t\tborder-bottom-color: #BBB;\n\t}\n\n\t/* Use distinguishing colors when user is interacting with the link */\n\ta[href]:focus,\n\ta[href]:hover {\n\t\tbackground: #f8f8f8;\n\t\tbackground: rgba(75%, 75%, 75%, .25);\n\t\tborder-bottom-width: 3px;\n\t\tmargin-bottom: -2px;\n\t}\n\ta[href]:active {\n\t\tcolor: #C00;\n\t\tborder-color: #C00;\n\t}\n\n\t/* Backout above styling for W3C logo */\n\t.head p:not(.copyright) > a,\n\t.head > a:first-child {\n\t\tborder: none;\n\t\ttext-decoration: none;\n\t\tbackground: transparent;\n\t}\n\n/******************************************************************************/\n/*                                    Images                                  */\n/******************************************************************************/\n\n\timg {\n\t\tborder-style: none;\n\t}\n\n\t/* For autogen numbers, add\n\t   .caption::before, figcaption::before { content: \"Figure \" counter(figure) \". \"; }\n\t*/\n\n\tfigure, .figure, .sidefigure {\n\t\tpage-break-inside: avoid;\n\t\ttext-align: center;\n\t\tmargin: 2.5em 0;\n\t}\n\t.figure img,    .sidefigure img,    figure img,\n\t.figure object, .sidefigure object, figure object {\n\t\tmax-width: 100%;\n\t\tmargin: auto;\n\t\theight: auto;\n\t}\n\t.figure pre, .sidefigure pre, figure pre {\n\t\ttext-align: left;\n\t\tdisplay: table;\n\t\tmargin: 1em auto;\n\t}\n\t.figure table, figure table {\n\t\tmargin: auto;\n\t}\n\t@media screen and (min-width: 20em) {\n\t\t.sidefigure {\n\t\t\tfloat: right;\n\t\t\twidth: 50%;\n\t\t\tmargin: 0 0 0.5em 0.5em;\n\t\t}\n\t}\n\t.caption, figcaption, caption {\n\t\tfont-style: italic;\n\t\tfont-size: 90%;\n\t}\n\t.caption::before, figcaption::before, figcaption > .marker {\n\t\tfont-weight: bold;\n\t}\n\t.caption, figcaption {\n\t\tcounter-increment: figure;\n\t}\n\n\t/* DL list is indented 2em, but figure inside it is not */\n\tdd > .figure, dd > figure { margin-left: -2em; }\n\n/******************************************************************************/\n/*                             Colored Boxes                                  */\n/******************************************************************************/\n\n\t.issue, .note, .example, .advisement, blockquote {\n\t\tpadding: .5em;\n\t\tborder: .5em;\n\t\tborder-left-style: solid;\n\t\tpage-break-inside: avoid;\n\t}\n\tspan.issue, span.note {\n\t\tpadding: .1em .5em .15em;\n\t\tborder-right-style: solid;\n\t}\n\n\t.issue,\n\t.note,\n\t.example,\n\t.advisement,\n\tblockquote {\n\t\tmargin: 1em auto;\n\t}\n\t.note  > p:first-child,\n\t.issue > p:first-child,\n\tblockquote > :first-child {\n\t\tmargin-top: 0;\n\t}\n\tblockquote > :last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n/** Blockquotes ***************************************************************/\n\n\tblockquote {\n\t\tborder-color: silver;\n\t}\n\n/** Open issue ****************************************************************/\n\n\t.issue {\n\t\tborder-color: #E05252;\n\t\tbackground: #FBE9E9;\n\t\tcounter-increment: issue;\n\t\toverflow: auto;\n\t}\n\t.issue::before, .issue > .marker {\n\t\tcolor: #AE1E1E;\n\t\tpadding-right: 1em;\n\t\ttext-transform: uppercase;\n\t}\n\t/* Add .issue::before { content: \"Issue \" counter(issue) \" \"; } for autogen numbers,\n\t   or use class=\"marker\" to mark up the issue number in source. */\n\n/** Example *******************************************************************/\n\n\t.example {\n\t\tborder-color: #E0CB52;\n\t\tbackground: #FCFAEE;\n\t\tcounter-increment: example;\n\t\toverflow: auto;\n\t\tclear: both;\n\t}\n\t.example::before, .example > .marker {\n\t\ttext-transform: uppercase;\n\t\tcolor: #827017;\n\t\tmin-width: 7.5em;\n\t\tdisplay: block;\n\t}\n\t/* Add .example::before { content: \"Example \" counter(example) \" \"; } for autogen numbers,\n\t   or use class=\"marker\" to mark up the example number in source. */\n\n/** Non-normative Note ********************************************************/\n\n\t.note {\n\t\tborder-color: #52E052;\n\t\tbackground: #E9FBE9;\n\t\toverflow: auto;\n\t}\n\n\t.note::before, .note > .marker,\n\tdetails.note > summary::before,\n\tdetails.note > summary > .marker {\n\t\ttext-transform: uppercase;\n\t\tdisplay: block;\n\t\tcolor: hsl(120, 70%, 30%);\n\t}\n\t/* Add .note::before { content: \"Note \"; } for autogen label,\n\t   or use class=\"marker\" to mark up the label in source. */\n\n\tdetails.note > summary {\n\t\tcolor: hsl(120, 70%, 30%);\n\t}\n\tdetails.note[open] > summary {\n\t\tborder-bottom: 1px silver solid;\n\t}\n\n/** Advisement Box ************************************************************/\n\t/*  for attention-grabbing normative statements */\n\n\t.advisement {\n\t\tborder-color: orange;\n\t\tborder-style: none solid;\n\t\tbackground: #FFEECC;\n\t}\n\tstrong.advisement {\n\t\tdisplay: block;\n\t\ttext-align: center;\n\t}\n\t.advisement > .marker {\n\t\tcolor: #B35F00;\n\t}\n\n/** Spec Obsoletion Notice ****************************************************/\n\t/* obnoxious obsoletion notice for older/abandoned specs. */\n\n\tdetails {\n\t\tdisplay: block;\n\t}\n\tsummary {\n\t\tfont-weight: bolder;\n\t}\n\n\t.annoying-warning:not(details),\n\tdetails.annoying-warning:not([open]) > summary,\n\tdetails.annoying-warning[open] {\n\t\tbackground: hsla(40,100%,50%,0.95);\n\t\tcolor: black;\n\t\tpadding: .75em 1em;\n\t\tborder: red;\n\t\tborder-style: solid none;\n\t\tbox-shadow: 0 2px 8px black;\n\t\ttext-align: center;\n\t}\n\t.annoying-warning :last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n@media not print {\n\tdetails.annoying-warning[open] {\n\t\tposition: fixed;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 2em;\n\t\tz-index: 1000;\n\t}\n}\n\n\tdetails.annoying-warning:not([open]) > summary {\n\t\ttext-align: center;\n\t}\n\n/** Entity Definition Boxes ***************************************************/\n\n\t.def {\n\t\tpadding: .5em 1em;\n\t\tbackground: #DEF;\n\t\tmargin: 1.2em 0;\n\t\tborder-left: 0.5em solid #8CCBF2;\n\t}\n\n/******************************************************************************/\n/*                                    Tables                                  */\n/******************************************************************************/\n\n\tth, td {\n\t\ttext-align: left;\n\t\ttext-align: start;\n\t}\n\n/** Property/Descriptor Definition Tables *************************************/\n\n\ttable.def {\n\t\t/* inherits .def box styling, see above */\n\t\twidth: 100%;\n\t\tborder-spacing: 0;\n\t}\n\n\ttable.def td,\n\ttable.def th {\n\t\tpadding: 0.5em;\n\t\tvertical-align: baseline;\n\t\tborder-bottom: 1px solid #bbd7e9;\n\t}\n\n\ttable.def > tbody > tr:last-child th,\n\ttable.def > tbody > tr:last-child td {\n\t\tborder-bottom: 0;\n\t}\n\n\ttable.def th {\n\t\tfont-style: italic;\n\t\tfont-weight: normal;\n\t\tpadding-left: 1em;\n\t\twidth: 3em;\n\t}\n\n\t/* For when values are extra-complex and need formatting for readability */\n\ttable td.pre {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t/* A footnote at the bottom of a def table */\n\ttable.def           td.footnote {\n\t\tpadding-top: 0.6em;\n\t}\n\ttable.def           td.footnote::before {\n\t\tcontent: \" \";\n\t\tdisplay: block;\n\t\theight: 0.6em;\n\t\twidth: 4em;\n\t\tborder-top: thin solid;\n\t}\n\n/** Data tables (and properly marked-up index tables) *************************/\n\t/*\n\t\t <table class=\"data\"> highlights structural relationships in a table\n\t\t when correct markup is used (e.g. thead/tbody, th vs. td, scope attribute)\n\n\t\t Use class=\"complex data\" for particularly complicated tables --\n\t\t (This will draw more lines: busier, but clearer.)\n\n\t\t Use class=\"long\" on table cells with paragraph-like contents\n\t\t (This will adjust text alignment accordingly.)\n\t\t Alternately use class=\"longlastcol\" on tables, to have the last column assume \"long\".\n\t*/\n\n\ttable {\n\t\tword-wrap: normal;\n\t\toverflow-wrap: normal;\n\t\thyphens: manual;\n\t}\n\n\ttable.data,\n\ttable.index {\n\t\tmargin: 1em auto;\n\t\tborder-collapse: collapse;\n\t\tborder: hidden;\n\t\twidth: 100%;\n\t}\n\ttable.data caption,\n\ttable.index caption {\n\t\tmax-width: 50em;\n\t\tmargin: 0 auto 1em;\n\t}\n\n\ttable.data td,  table.data th,\n\ttable.index td, table.index th {\n\t\tpadding: 0.5em 1em;\n\t\tborder-width: 1px;\n\t\tborder-color: silver;\n\t\tborder-top-style: solid;\n\t}\n\n\ttable.data thead td:empty {\n\t\tpadding: 0;\n\t\tborder: 0;\n\t}\n\n\ttable.data  thead,\n\ttable.index thead,\n\ttable.data  tbody,\n\ttable.index tbody {\n\t\tborder-bottom: 2px solid;\n\t}\n\n\ttable.data colgroup,\n\ttable.index colgroup {\n\t\tborder-left: 2px solid;\n\t}\n\n\ttable.data  tbody th:first-child,\n\ttable.index tbody th:first-child  {\n\t\tborder-right: 2px solid;\n\t\tborder-top: 1px solid silver;\n\t\tpadding-right: 1em;\n\t}\n\n\ttable.data th[colspan],\n\ttable.data td[colspan] {\n\t\ttext-align: center;\n\t}\n\n\ttable.complex.data th,\n\ttable.complex.data td {\n\t\tborder: 1px solid silver;\n\t\ttext-align: center;\n\t}\n\n\ttable.data.longlastcol td:last-child,\n\ttable.data td.long {\n\t vertical-align: baseline;\n\t text-align: left;\n\t}\n\n\ttable.data img {\n\t\tvertical-align: middle;\n\t}\n\n\n/*\nAlternate table alignment rules\n\n\ttable.data,\n\ttable.index {\n\t\ttext-align: center;\n\t}\n\n\ttable.data  thead th[scope=\"row\"],\n\ttable.index thead th[scope=\"row\"] {\n\t\ttext-align: right;\n\t}\n\n\ttable.data  tbody th:first-child,\n\ttable.index tbody th:first-child  {\n\t\ttext-align: right;\n\t}\n\nPossible extra rowspan handling\n\n\ttable.data  tbody th[rowspan]:not([rowspan='1']),\n\ttable.index tbody th[rowspan]:not([rowspan='1']),\n\ttable.data  tbody td[rowspan]:not([rowspan='1']),\n\ttable.index tbody td[rowspan]:not([rowspan='1']) {\n\t\tborder-left: 1px solid silver;\n\t}\n\n\ttable.data  tbody th[rowspan]:first-child,\n\ttable.index tbody th[rowspan]:first-child,\n\ttable.data  tbody td[rowspan]:first-child,\n\ttable.index tbody td[rowspan]:first-child{\n\t\tborder-left: 0;\n\t\tborder-right: 1px solid silver;\n\t}\n*/\n\n/******************************************************************************/\n/*                                  Indices                                   */\n/******************************************************************************/\n\n\n/** Table of Contents *********************************************************/\n\n\t.toc a {\n\t\t/* More spacing; use padding to make it part of the click target. */\n\t\tpadding-top: 0.1rem;\n\t\t/* Larger, more consistently-sized click target */\n\t\tdisplay: block;\n\t\t/* Reverse color scheme */\n\t\tcolor: black;\n\t\tborder-color: #0071BC;\n\t}\n\t.toc a:visited {\n\t\tborder-color: #154862;\n\t}\n\t.toc a:not(:focus):not(:hover) {\n\t\t/* Allow colors to cascade through from link styling */\n\t\tborder-bottom-color: transparent;\n\t}\n\n\t.toc, .toc ol, .toc ul, .toc li {\n\t\tlist-style: none; /* Numbers must be inlined into source */\n\t\t/* because generated content isn't search/selectable and markers can't do multilevel yet */\n\t\tmargin:  0;\n\t\tpadding: 0;\n\t\tline-height: 1.1rem; /* consistent spacing */\n\t}\n\n\t/* ToC not indented until third level, but font style & margins show hierarchy */\n\t.toc > li             { font-weight: bold;   }\n\t.toc > li li          { font-weight: normal; }\n\t.toc > li li li       { font-size:   95%;    }\n\t.toc > li li li li    { font-size:   90%;    }\n\t.toc > li li li li li { font-size:   85%;    }\n\n\t.toc > li             { margin: 1.5rem 0;    }\n\t.toc > li li          { margin: 0.3rem 0;    }\n\t.toc > li li li       { margin-left: 2rem;   }\n\n\t/* Section numbers in a column of their own */\n\t.toc .secno {\n\t\tfloat: left;\n\t\twidth: 4rem;\n\t\twhite-space: nowrap;\n\t}\n\t.toc > li li li li .secno {\n\t\tfont-size: 85%;\n\t}\n\t.toc > li li li li li .secno {\n\t\tfont-size: 100%;\n\t}\n\n\t:not(li) > .toc              { margin-left:  5rem; }\n\t.toc .secno                  { margin-left: -5rem; }\n\t.toc > li li li .secno       { margin-left: -7rem; }\n\t.toc > li li li li .secno    { margin-left: -9rem; }\n\t.toc > li li li li li .secno { margin-left: -11rem; }\n\n\t/* Tighten up indentation in narrow ToCs */\n\t@media (max-width: 30em) {\n\t\t:not(li) > .toc              { margin-left:  4rem; }\n\t\t.toc .secno                  { margin-left: -4rem; }\n\t\t.toc > li li li              { margin-left:  1rem; }\n\t\t.toc > li li li .secno       { margin-left: -5rem; }\n\t\t.toc > li li li li .secno    { margin-left: -6rem; }\n\t\t.toc > li li li li li .secno { margin-left: -7rem; }\n\t}\n\n\t.toc li {\n\t\tclear: both;\n\t}\n\n\n/** Index *********************************************************************/\n\n\t/* Index Lists: Layout */\n\tul.index       { margin-left: 0; columns: 15em; text-indent: 1em hanging; }\n\tul.index li    { margin-left: 0; list-style: none; break-inside: avoid; }\n\tul.index li li { margin-left: 1em; }\n\tul.index dl    { margin-top: 0; }\n\tul.index dt    { margin: .2em 0 .2em 20px;}\n\tul.index dd    { margin: .2em 0 .2em 40px;}\n\t/* Index Lists: Typography */\n\tul.index ul,\n\tul.index dl { font-size: smaller; }\n\t@media not print {\n\t\tul.index li span {\n\t\t\twhite-space: nowrap;\n\t\t\tcolor: transparent;\n\t\t}\n\t\tul.index li a:hover + span,\n\t\tul.index li a:focus + span {\n\t\t\tcolor: #707070;\n\t\t}\n\t}\n\n/** Index Tables *****************************************************/\n\t/* See also the data table styling section, which this effectively subclasses */\n\n\ttable.index {\n\t\tfont-size: small;\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\t\ttext-align: left;\n\t\tmargin: 1em 0;\n\t}\n\n\ttable.index td,\n\ttable.index th {\n\t\tpadding: 0.4em;\n\t}\n\n\ttable.index tr:hover td:not([rowspan]),\n\ttable.index tr:hover th:not([rowspan]) {\n\t\tbackground: #f7f8f9;\n\t}\n\n\t/* The link in the first column in the property table (formerly a TD) */\n\ttable.index th:first-child a {\n\t\tfont-weight: bold;\n\t}\n\n/** Outdated warning **********************************************************/\n\na#outdated-note {\n\tcolor: white;\n}\n\na#outdated-note:hover {\n\tbackground: transparent;\n}\n\n.outdated-spec {\n\tbackground-color: rgba(0,0,0,0.5);\n}\n\n.outdated-warning {\n\tposition: fixed;\n\tbottom: 50%;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 auto;\n\twidth: 50%;\n\tbackground: maroon;\n\tcolor: white;\n\tborder-radius: 1em;\n\tbox-shadow: 0 0 1em red;\n\tpadding: 2em;\n\ttext-align: center;\n\tz-index: 2;\n}\n\n.edited-rec-warning {\n\tbackground: darkorange;\n\tbox-shadow: 0 0 1em;\n}\n\n.outdated-warning button {\n\tposition: absolute;\n\ttop: 0;\n\tright:0;\n\tmargin: 0;\n\tborder: 0;\n\tpadding: 0.25em 0.5em;\n\tbackground: transparent;\n\tcolor: white;\n\tfont:1em sans-serif;\n\ttext-align:center;\n}\n\n.outdated-warning span {\n\tdisplay: block;\n}\n\n.outdated-collapsed {\n\tbottom: 0;\n\tborder-radius: 0;\n\twidth: 100%;\n\tpadding: 0;\n}\n\n/******************************************************************************/\n/*                                    Print                                   */\n/******************************************************************************/\n\n\t@media print {\n\t\t/* Pages have their own margins. */\n\t\thtml {\n\t\t\tmargin: 0;\n\t\t}\n\n\t\t.outdated-warning {\n\t\t\tposition: absolute;\n\t\t\tborder-style: solid;\n\t\t\tborder-color: red;\n\t\t}\n\n\t\t.outdated-warning input {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t@page {\n\t\tmargin: 1.5cm 1.1cm;\n\t}\n\n/******************************************************************************/\n/*                                    Legacy                                  */\n/******************************************************************************/\n\n\t/* This rule is inherited from past style sheets. No idea what it's for. */\n\t.hide { display: none; }\n\n\n\n/******************************************************************************/\n/*                             Overflow Control                               */\n/******************************************************************************/\n\n\t.figure .caption, .sidefigure .caption, figcaption {\n\t\t/* in case figure is overlarge, limit caption to 50em */\n\t\tmax-width: 50rem;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\t.overlarge > table {\n\t\t/* limit preferred width of table */\n\t\tmax-width: 50em;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t@media (min-width: 55em) {\n\t\t.overlarge {\n\t\t\tmargin-left: calc(13px + 26.5rem - 50vw);\n\t\t\tmargin-right: calc(13px + 26.5rem - 50vw);\n\t\t\tmax-width: none;\n\t\t}\n\t}\n\n\t@media not print {\n\t\t.overlarge {\n\t\t\toverflow-x: auto;\n\t\t\t/* See Lea Verou's explanation background-attachment:\n\t\t\t * http://lea.verou.me/2012/04/background-attachment-local/\n\t\t\t *\n\t\t\tbackground: top left  / 4em 100% linear-gradient(to right,  #ffffff, rgba(255, 255, 255, 0)) local,\n\t\t\t            top right / 4em 100% linear-gradient(to left, #ffffff, rgba(255, 255, 255, 0)) local,\n\t\t\t            top left  / 1em 100% linear-gradient(to right,  #c3c3c5, rgba(195, 195, 197, 0)) scroll,\n\t\t\t            top right / 1em 100% linear-gradient(to left, #c3c3c5, rgba(195, 195, 197, 0)) scroll,\n\t\t\t            white;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\t*/\n\t\t}\n\t}\n","/******************************************************************************/\n/*                                   Body                                     */\n/******************************************************************************/\n\n\t.rdforms-specs {\n\t\tcounter-reset: example figure issue;\n\n\t\t/* Layout */\n\t\tmax-width: 50em;               /* limit line length to 50em for readability   */\n\t\tmargin: 0 auto;                /* center text within page                     */\n\t\tpadding: 1.6em 1.5em 2em 50px; /* assume 16px font size for downlevel clients */\n\t\tpadding: 1.6em 1.5em 2em calc(26px + 1.5em); /* leave space for status flag     */\n\n\t\t/* Typography */\n\t\tline-height: 1.5;\n\t\tfont-family: sans-serif;\n\t\twidows: 2;\n\t\torphans: 2;\n\t\tword-wrap: break-word;\n\t\toverflow-wrap: break-word;\n\n\t\t/* Colors */\n\t\tcolor: black;\n\t\tbackground: white top left fixed no-repeat;\n\t\tbackground-size: 25px auto;\n\t}\n\n\n/******************************************************************************/\n/*                                    Print                                   */\n/******************************************************************************/\n\n@media print {\n\t/* Serif for print. */\n\t.rdforms-specs {\n\t\tfont-family: serif;\n\t}\n}\n\n/* Floating sidebar */\n@media screen {\n\t.rdforms-specs.toc-sidebar #toc {\n\t\tposition: fixed;\n\t\ttop: 0; bottom: 0;\n\t\tleft: 0;\n\t\twidth: 23.5em;\n\t\tmax-width: 80%;\n\t\tmax-width: calc(100% - 2em - 26px);\n\t\toverflow: auto;\n\t\tpadding: 0 1em;\n\t\tpadding-left: 42px;\n\t\tpadding-left: calc(1em + 26px);\n\t\tbackground: inherit;\n\t\tbackground-color: #f7f8f9;\n\t\tz-index: 1;\n\t\tbox-shadow: -.1em 0 .25em rgba(0,0,0,.1) inset;\n\t}\n\t.rdforms-specs.toc-sidebar #toc h2 {\n\t\tmargin-top: .8rem;\n\t\tfont-variant: small-caps;\n\t\tfont-variant: all-small-caps;\n\t\ttext-transform: lowercase;\n\t\tfont-weight: bold;\n\t\tcolor: gray;\n\t\tcolor: hsla(203,20%,40%,.7);\n\t}\n\t.rdforms-specs.toc-sidebar #toc-jump:not(:focus) {\n\t\twidth: 0;\n\t\theight: 0;\n\t\tpadding: 0;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t}\n}\n/* Hide main scroller when only the ToC is visible anyway */\n@media screen and (max-width: 28em) {\n\t.rdforms-specs.toc-sidebar {\n\t\toverflow: hidden;\n\t}\n}\n\n/* Sidebar with its own space */\n@media screen and (min-width: 78em) {\n\t.rdforms-specs:not(.toc-inline) #toc {\n\t\tposition: fixed;\n\t\ttop: 0; bottom: 0;\n\t\tleft: 0;\n\t\twidth: 23.5em;\n\t\toverflow: auto;\n\t\tpadding: 0 1em;\n\t\tpadding-left: 42px;\n\t\tpadding-left: calc(1em + 26px);\n\t\tbackground: inherit;\n\t\tbackground-color: #f7f8f9;\n\t\tz-index: 1;\n\t\tbox-shadow: -.1em 0 .25em rgba(0,0,0,.1) inset;\n\t}\n\t.rdforms-specs:not(.toc-inline) #toc h2 {\n\t\tmargin-top: .8rem;\n\t\tfont-variant: small-caps;\n\t\tfont-variant: all-small-caps;\n\t\ttext-transform: lowercase;\n\t\tfont-weight: bold;\n\t\tcolor: #154862;\n\t}\n\n\t.rdforms-specs:not(.toc-inline) {\n\t\tpadding-left: 29em;\n\t}\n\t/* See also Overflow section at the bottom */\n\n\t.rdforms-specs:not(.toc-inline) #toc-jump:not(:focus) {\n\t\twidth: 0;\n\t\theight: 0;\n\t\tpadding: 0;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t}\n}\n@media screen and (min-width: 90em) {\n\t.rdforms-specs:not(.toc-inline) {\n\t\tmargin: 0 4em;\n\t}\n}\n\n\n.rdforms-specs.toc-sidebar #toc :not(li) > .toc              { margin-left:  4rem; }\n.rdforms-specs.toc-sidebar #toc .toc .secno                  { margin-left: -4rem; }\n.rdforms-specs.toc-sidebar #toc .toc > li li li              { margin-left:  1rem; }\n.rdforms-specs.toc-sidebar #toc .toc > li li li .secno       { margin-left: -5rem; }\n.rdforms-specs.toc-sidebar #toc .toc > li li li li .secno    { margin-left: -6rem; }\n.rdforms-specs.toc-sidebar #toc .toc > li li li li li .secno { margin-left: -7rem; }\n\n@media screen and (min-width: 78em) {\n\t.rdforms-specs:not(.toc-inline) :not(li) > .toc              { margin-left:  4rem; }\n\t.rdforms-specs:not(.toc-inline) .toc .secno                  { margin-left: -4rem; }\n\t.rdforms-specs:not(.toc-inline) .toc > li li li              { margin-left:  1rem; }\n\t.rdforms-specs:not(.toc-inline) .toc > li li li .secno       { margin-left: -5rem; }\n\t.rdforms-specs:not(.toc-inline) .toc > li li li li .secno    { margin-left: -6rem; }\n\t.rdforms-specs:not(.toc-inline) .toc > li li li li li .secno { margin-left: -7rem; }\n}\n\n@media screen and (min-width: 78em) {\n\t.rdforms-specs:not(.toc-inline) .overlarge {\n\t\t/* 30.5em body padding 50em content area */\n\t\tmargin-left: calc(40em - 50vw) !important;\n\t\tmargin-right: calc(40em - 50vw) !important;\n\t}\n}\n@media screen and (min-width: 90em) {\n\t.rdforms-specs:not(.toc-inline) .overlarge {\n\t\t/* 4em html margin 30.5em body padding 50em content area */\n\t\tmargin-left: 0 !important;\n\t\tmargin-right: calc(84.5em - 100vw) !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
